<template>
    <el-menu
        class="data-management-center-aside-menu"
        :collapse-transition="false"
        :default-active="$route.path"
        :unique-opened="true"
        :router="true"
        background-color="#1a244d"
        text-color="rgb(230, 237, 255)"
        active-text-color="#ffffff"
    >


        <!-- 一级菜单 -->
        <template v-for="item in routerSides">

            <el-submenu v-if="item.children && item.children.length" :index="item.path" :key="item.path">
                <template slot="title"><i :class="item.meta.icon" style="margin-right: 5px;"></i><span>{{item.meta.title}}</span></template>

                <!-- 二级菜单 -->
                <template v-for="itemChild in item.children">
                    <el-submenu v-if="itemChild.children && itemChild.children.length && !itemChild.siderHidden"
                                :index="itemChild.path" :key="itemChild.path">
                        <template slot="title"><i :class="itemChild.meta.icon"></i><span>{{itemChild.meta.title}}</span>
                        </template>

                        <!-- 三级菜单 -->
                        <el-menu-item v-for="itemChild_Child in itemChild.children" :index="itemChild_Child .path"
                                      :key="itemChild_Child.path">
                            <i :class="itemChild_Child.meta.icon"></i><span
                            slot="title">{{itemChild_Child.meta.title}}</span></el-menu-item>

                    </el-submenu>

                    <el-menu-item v-else-if="!itemChild.meta.menuHide" :index="itemChild.path" :key="itemChild.path" i>
                        <i :class="itemChild.meta.icon"></i><span slot="title">{{itemChild.meta.title}}</span>
                    </el-menu-item>
                </template>
            </el-submenu>

            <el-menu-item v-else-if="!item.siderHidden" :index="item.path" :key="item.path"><i
                :class="item.meta.icon" style="margin-right: 5px;"></i><span slot="title">{{item.meta.title}}</span></el-menu-item>

        </template>

    </el-menu>

</template>

<script>
import {CommonUrls, getItemPath} from '@/utils/router-helper.js';

import {mapState} from 'vuex';
import $ from 'jquery';

const MODULE_BASE_URL = CommonUrls.Root;
export default {
    name: 'Menu',
    inject: ['reload'],
    components: {
    },
    data() {
        return {
            res: ''
        };
    },
    computed: {
        ...mapState({
            routerSides: state => state.permission.routers,
        }),
    },

    mounted() {

    },
    methods: {
        getItemPath(...paths) {
            return getItemPath(MODULE_BASE_URL, ...paths);
        },


    },
};
</script>
<style lang="less">
    @buttonWidth: 50px;

    .data-management-center-aside-menu {
        text-align: left;

        &.el-menu {
            border-right: none;

            .submenu-icon,
            .item-icon {
                display: inline-block;
                width: 16px;
                height: 16px;
                margin-right: 15px;
            }

            .submenu-icon {
                &.submenu-icon-rsu-message {
                    background: url("~@/assets/data-nav/rsu-message.png") no-repeat center center;
                    background-size: contain;
                }
            }

            .el-menu-item:hover .submenu-icon,
            .el-submenu:hover .submenu-icon {
                &.submenu-icon-rsu-message {
                    background: url("~@/assets/data-nav/rsu-message-hover.png") no-repeat center center;
                    background-size: contain;
                }
            }

            .el-menu-item {
                height: 56px;
                line-height: 56px;
                // border-left: 3px solid transparent !important;

                &.is-active {
                    border-left: 3px solid #006aff !important;
                    background: #006aff !important;
                    color: #fff !important;
                }
            }

            .el-submenu {
                &.is-active {
                    .el-submenu__title {
                        color: #fff !important;
                    }
                }
            }
        }
    }
</style>
